import { Outlet, useLocation } from "react-router-dom";
import { AppErrorBoundary } from "@froppio/web-telemetry";
import { renderCrashScreen } from "@/core/telemetry/renderCrashScreen";

export function AppLayout() {
  const { pathname } = useLocation();
  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-background pb-[env(safe-area-inset-bottom)]">
      <a href="#main-content"
        onClick={(event) => { event.preventDefault(); document.getElementById("main-content")?.focus(); }}
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:rounded-xl focus:bg-card focus:p-3">Skip to content</a>
      <main id="main-content" tabIndex={-1} className="min-h-0 flex-1 overflow-hidden">
        <AppErrorBoundary scope="page" resetKey={pathname} fallback={renderCrashScreen}>
          <Outlet />
        </AppErrorBoundary>
      </main>
    </div>
  );
}